import { map } from 'lodash-es'
import { Attributes, Fragment, ReactNode } from 'react'

import { ScrollContainer } from '@/components/ScrollContainer'

import styles from './AsideList.module.css'

export interface AsideListProps<T> {
  children: (item: T, index: number) => ReactNode
  items?: T[]
  keyExtractor?: (item: T, index: number) => Attributes['key']
}

const defaultKeyExtractor = <T,>(_: T, index: number) => index

export const AsideList = <T = unknown,>({
  children,
  items,
  keyExtractor = defaultKeyExtractor,
}: AsideListProps<T>) => {
  if (keyExtractor == undefined) {
    keyExtractor = defaultKeyExtractor
  }
  if (keyExtractor === defaultKeyExtractor) {
    console.warn('keyExtractor is not provided, using default keyExtractor which uses index')
  }

  return (
    <ScrollContainer contentClassName={styles.scrollContainer}>
      <ul className={styles.asideList}>
        {map(items, (v, i) => {
          return <Fragment key={keyExtractor(v, i)}>{children(v, i)}</Fragment>
        })}
      </ul>
    </ScrollContainer>
  )
}

export default AsideList
